import React from 'react';
import { HashRouter, Route } from 'react-router-dom';

import { RouteWithLayout } from '@components';
import { AuthService } from '@services';

// Layouts
import { Main } from 'layouts';

// Views
import {
  Home,
  HomeExternal,
  Login,
  NoticePrivacy,
  ProfileSettings,
  UnlockUser,
  WelcomePassword,
} from 'views';

const Routes = () => {
  const isAuth = AuthService.authentication.isAuth;

  return (
    <>
      <div id="loading-bar" style={{ position: 'absolute' }}></div>

      <HashRouter>
        {/* Not Required Authorization */}
        <Route
          exact
          path="/login"
          component={Login}
        />
        <Route
          exact
          path="/bienvenida"
          component={WelcomePassword}
        />
        <Route
          exact
          path="/cambiar-password"
          component={WelcomePassword}
        />
        <Route
          exact
          path="/unlock-user"
          component={UnlockUser}
        />
        <Route
          exact
          path="/notice-privacy"
          component={NoticePrivacy}
        />
        <RouteWithLayout
          exact
          path="/home"
          layout={Main}
          component={Home}
          auth={isAuth}
          state={{ backButton: false }}
        />
        <RouteWithLayout
          exact
          path="/"
          layout={Main}
          component={Home}
          auth={isAuth}
          state={{ backButton: false }}
        />
        <RouteWithLayout
          exact
          path="/bienvenida/externo"
          layout={Main}
          component={HomeExternal}
          auth={isAuth}
        />
        <RouteWithLayout
          exact
          path="/configuraperfil"
          layout={Main}
          component={ProfileSettings}
          auth={isAuth}
          state={{ backButton: true }}
        />
      </HashRouter>
    </>
  );
};

export default Routes;
